import React from 'react';
import TranslationText from '@Components/Utilities/TranslationText';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import translator from '@Components/Utilities/Translator';

const AuctioneerDirectoryListing = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const auctioneerButtons = currentSite?.Site?.IsAuctionTime || currentSite?.Site?.IsAuctionValues ? (
        <>
            {props.BilledUser && (
                <a
                    className="block-btn"
                    href={props.AuctioneerConsignmentLink}
                    target={currentSite?.Site?.IsAuctionValues ? "_blank" : "_self"}
                    aria-label={currentSite?.Site?.IsAuctionValues ? translator.translate('sandhills.sellwithus') + " (" + translator.translate('sandhills.opensinanewtab') + ")" : translator.translate('sandhills.sellwithus')}
                >
                    <TranslationText tKey='sandhills.sellwithus' />
                </a>
            )}
            {props.Website && (
                <a className="block-btn black-btn" href={props.Website} target="_blank" aria-label={translator.translate('sandhills.tradepubwebsite.mvc.visitourwebsite') + " (" + translator.translate('sandhills.opensinanewtab') + ")" }>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.visitourwebsite' />
                </a>
            )}
            <a
                className="block-btn black-btn"
                href={currentSite?.Site?.IsAuctionValues ? props.ATExternalAuctioneerDetailsPage : props.AuctioneerDetailsPage}
                target={currentSite?.Site?.IsAuctionValues ? "_blank" : "_self"}
                aria-label={currentSite?.Site?.IsAuctionValues ? translator.translate('sandhills.tradesites.mvc.viewauctions') + " (" + translator.translate('sandhills.opensinanewtab') + ")" : translator.translate('sandhills.tradesites.mvc.viewauctions')}
            >
                <TranslationText tKey='sandhills.tradesites.mvc.viewauctions' />
            </a>
            {props.DisplayAuctionResultsLink && (
                 <a className="block-btn black-btn" href={props.AuctioneerAuctionResultsPage}>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.auctionresults' />
                </a>
            )}
        </>
    ) : (
        <>
            <a className="block-btn" href={props.AuctioneerDetailsPage}>
                <TranslationText tKey='sandhills.tradesites.mvc.viewauctions' />
            </a>
            {props.Website && (
                    <a className="block-btn black-btn" href={props.Website} target="_blank" aria-label={translator.translate('sandhills.tradepubwebsite.mvc.visitourwebsite') + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.visitourwebsite' />
                </a>
            )}
        </>
    );

    return (
        <div className="list dealer-box cf">
            <div className="list-details">
                <h2> <a href={props.AuctioneerDetailsPage}>{props.AccountName}</a></h2>
                {props.PremierSeller &&
                    <div className="premier-seller">
                        <i class="fas fa-star"></i>
                        <TranslationText tKey='sandhills.tradepubwebsite.mvc.premierseller' />
                    </div>}
                <div className="list-location">
                    <strong><TranslationText tKey='sandhills.tradepubwebsite.mvc.contactinfo' /></strong><br></br>
                    {props.Address}<br></br>
                    {props.Location}<br></br>
                    <TranslationText tKey='sandhills.phone' />: <a href={'tel:' + props.UnformattedPhone} onClick={() => gtmPushEvent(gtmEventType.call)}>{props.Phone}</a>
                    {props.DistanceFrom &&
                        <div className='distance-away'>
                            <i className='fas fa-location-dot' /> {props.DistanceFrom}
                        </div>}
                </div>

            </div>
            <div className="list-image">
                {props.LogoMediaURL && <a href={props.AuctioneerDetailsPage}><img src={props.LogoMediaURL} alt={props.AccountName}></img></a>}
            </div>
            <div className="list-items-sold">
                {(props.TotalItemsSold !== null && props.TotalItemsSold !== undefined) &&
                    <>{props.TotalItemsSold} <TranslationText tKey='sandhills.tradepubwebsite.mvc.itemssold' /></>
                }
            </div> 

            <div className="list-contact">
                {auctioneerButtons}
            </div>
        </div>
    );
};

export default AuctioneerDirectoryListing;